<h1 mat-dialog-title class="aza-pa-dialog-title" translate>CREATE_NEW_EMAIL_CAMPAIGN</h1>

<div *ngIf="isLoaded" mat-dialog-content class="aza-pa-dialog-content">
    <div class="text-fields aza-pa-two-columns-grid aza-pa-margin-block">
        <azavista-grouped-fields
            (valuesChanged)="onGroupedFieldChanges($event)"
            [data]="groupedFields"
        ></azavista-grouped-fields>
    </div>
</div>

<div mat-dialog-actions class="dialog-actions aza-pa-dialog-actions">
    <azavista-button (click)="onCancel()" class="aza-pa-dialog-action-cancel-button"><span translate>CANCEL</span></azavista-button>
    <azavista-button (click)="onCreate()" [disabled]="!isValid()" color="primary" class="aza-pa-dialog-action-apply-button"><span translate>CREATE</span>
    </azavista-button>
</div>
